import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { navigateToQuienesSomos } from '../../../redux/slices/uiSlice';
import ImageCard from '../../../components/ImageCard';
import card02 from '../../../assets/images/chapultepec.jpg';
import { useInView, motion } from 'framer-motion';

export default function VisualRest() {
  const ref = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isInView = useInView(ref, { amount: 0.6, margin: '-100px 0px -100px 0px' });
  const [hasBeenViewed, setHasBeenViewed] = useState(false);

  useEffect(() => {
    if (isInView && !hasBeenViewed) {
      setHasBeenViewed(true);
    }
  }, [isInView, hasBeenViewed]);

  const handleImageClick = () => {
    // Usar Redux para manejar la navegación
    dispatch(navigateToQuienesSomos());
    // Navegar usando React Router
    navigate('/quienesomos');
  };

  return (
    <div
      ref={ref}
      className={`relative w-full transition-all duration-700 ease-out ${
        hasBeenViewed ? 'bg-custom-blue py-20' : 'bg-white py-12'
      }`}
    >
      <div className="max-w-7xl w-full mx-auto py-10">
        <div className="flex flex-col items-start justify-center leading-none py-4 w-full pl-4">
          <motion.h1
            className={`font-serif text-5xl leading-[55px] tracking-[0%] font-light transition-colors duration-700 ${
              hasBeenViewed ? 'text-white' : 'text-gray-900'
            }`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.2 }}
          >
            Abogados.
          </motion.h1>
          <motion.h1
            className={`font-serif text-5xl leading-[55px] tracking-[0%] font-light transition-colors duration-700 ${
              hasBeenViewed ? 'text-white' : 'text-gray-900'
            }`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.2 }}
          >
            Documentos.
          </motion.h1>
          <motion.h1
            className={`font-serif text-5xl leading-[55px] tracking-[0%] font-bold italic transition-colors duration-700 ${
              hasBeenViewed ? 'text-white' : 'text-gray-900'
            }`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.2 }}
          >
            Lo que necesites...
          </motion.h1>
        </div>
        <motion.div
          className="flex px-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <ImageCard
            backgroundImage={card02}
            text="Haz click aquí para conocer más"
            onClick={handleImageClick}
          />
        </motion.div>
      </div>
    </div>
  );
}
